import { normalizeCommunityPeopleSearch } from "/app/apps/web/src/routes/_app/community/people/index.tsx?tsr-shared=1";
const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/community/people/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/community/people/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { buildPrivatePageMetaTags } from "@/lib/seo-meta";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_app/community/people/")({
  validateSearch: normalizeCommunityPeopleSearch,
  loaderDeps: () => ({}),
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const tMeta = createTranslator({
      locale,
      messages,
      namespace: "globals.metadata"
    });
    return {
      meta: buildPrivatePageMetaTags(tMeta("communityPeople"))
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
export { normalizeCommunityPeopleSearch } from "/app/apps/web/src/routes/_app/community/people/index.tsx?tsr-shared=1";